module.exports = __webpack_public_path__ + "img/localhost_8080_.9749694f.png";